import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { FHEContainer } from 'data/components';
import { Toastr, tools } from 'data/common';
import renderEnvComponent from 'data/common/renderEnvComponent';
import { TableHomeTickets } from '../tables';
import { getHomeTickets } from '../../../data/Homes/actions';
import getSelectors from '../selectors';

class HomeTickets extends PureComponent {
    static propTypes = {
        getHomeTickets: PropTypes.func.isRequired,
        isActive: PropTypes.bool,
        homeId: PropTypes.string.isRequired
    };

    static defaultProps = {
        isActive: true
    };

    constructor(props) {
        super(props);
        this.state = {
            loading: props.isActive,
            needGetData: props.isActive,
            fetching: false,
            ticketsInitialized: false,
            homeTickets: {},
            error: null
        };
    }
    static getDerivedStateFromProps(props, state) {
        const { needGetData, loading, error, fetching, ticketsInitialized } = state;
        const { isActive } = props;

        if (!ticketsInitialized && isActive && !needGetData && !loading && !error && !fetching) return { needGetData: true, loading: true };
        return null;
    }
    componentDidMount() {
        const { needGetData } = this.state;
        if (needGetData) this.getTickets();
    }

    componentDidUpdate() {
        const { isActive } = this.props;
        const { needGetData, fetching, error, ticketsInitialized } = this.state;

        if (!ticketsInitialized && isActive && needGetData && !fetching && !error) {
            this.getTickets();
        }
    }

    getTickets = () => {
        const { getHomeTickets, homeId } = this.props;
        this.state.fetching = true;
        getHomeTickets(homeId)
            .then(tickets => {
                this.setState({
                    error: null,
                    loading: false,
                    fetching: false,
                    needGetData: false,
                    ticketsInitialized: true,
                    homeTickets: tickets
                });
            })
            .catch(err => {
                const message = Translator.translateWithFallback(`api.message.${err.message ? err.message : err}`, 'api.message.default');
                Toastr.error(message);
                this.setState({ error: message, loading: false, needGetData: false, fetching: false });
            });
    };

    retryGetData = () => {
        this.setState({ error: null, loading: true, needGetData: true });
    };

    renderChildren = () => {
        const { homeTickets } = this.state;
        return <TableHomeTickets tickets={homeTickets} />;
    };

    render() {
        const { error, loading } = this.state;

        return <FHEContainer hasNoClassContainer loading={loading} error={error} onClickFunc={this.retryGetData} onRender={this.renderChildren} />;
    }
}

function mapStateToProps(state, props) {
    const { history, match } = props;
    const homeId = match.params.homeId;
    const selectors = getSelectors(history.environment);
    return {
        homeId,
        profile: selectors.getProfile(state)
    };
}
export default withRouter(
    renderEnvComponent(
        'scenes/Home/sections/HomeTickets',
        connect(
            mapStateToProps,
            (dispatch, ownProps) => bindActionCreators(tools.mergePropsToAction(ownProps.history.environment, { getHomeTickets }), dispatch)
        )(HomeTickets)
    )
);



// WEBPACK FOOTER //
// ./environments/genericEnv/scenes/Home/sections/HomeTickets.js